import axios, { AxiosRequestConfig } from 'axios';

/**
 *  Axios instance that points to the API_HOST in .env
 *  This instance uses an interceptor https://github.com/axios/axios#interceptors
 *  to append an auth token to each request
 */

const DEFAULT_AXIOS_TIMEOUT_SECS = 30; // Default timeout for requests in seconds

export const DEFAULT_AXIOS_OPTIONS: AxiosRequestConfig = {
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
  timeout: DEFAULT_AXIOS_TIMEOUT_SECS * 1000,
};

export const getAxiosOptions = (options: AxiosRequestConfig = {}): AxiosRequestConfig => ({
  ...DEFAULT_AXIOS_OPTIONS,
  ...options,
});

const createAxiosInstance = (baseURL: string) =>
  axios.create({
    ...DEFAULT_AXIOS_OPTIONS,
    baseURL,
    responseType: 'json',
  });

export const axiosInstanceSADL = createAxiosInstance(process.env.REACT_APP_SADL_API_HOST);

// SAVI-8933 T3/T4: savi-pin-oprf (pepper signer). Same Auth0 JWT as the main instance, own
// base URL/service - deliberately not proxied through savi-api (see pin-auth-services.md).
export const axiosInstanceSaviPinOprf = createAxiosInstance(process.env.REACT_APP_SAVI_PIN_OPRF_HOST as string);

const axiosInstance = createAxiosInstance(process.env.REACT_APP_SAVI_API_HOST);

export default axiosInstance;
